import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getEmployeeTimesheet = (eid, query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/timesheet/${eid}${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getTimesheetByProjectId = (pid, query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/timesheet/project/${pid}${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createTimesheet = (data, token) =>
  axios.post(`${baseUrl}/timesheet`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteTimesheet = (id, token) =>
  axios.delete(`${baseUrl}/timesheet/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateTimesheet = (id, data, token) =>
  axios.put(`${baseUrl}/timesheet/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
export const patchApproveRejectTimesheet = (id, token, data) => {
  let url = `${baseUrl}/timesheetApprovalstatus/${id}`;
  return axios.patch(url, data, {
    headers: {
      authorization: token,
    },
  });
};
// export const getProjectsByUserId = (id, query, token) => {
//     let qs = buildQuery(query);
//     let url = `${baseUrl}/projects/user/${id}${qs}`;
//     return axios.get(url, {
//         headers: {
//             authorization: token
//         }
//     })
// }
